export default __webpack_public_path__ + "static/media/ic_bone_96.e1690bd1.svg";